module.exports = __webpack_public_path__ + "img/proveedoresq.96a7740a.png";